<template>
  <div>

   
    <el-row>
      <el-col :span="24">
        <el-card shadow="never">
        
          <el-select
            size="mini"
            class="form-group border-input"
            placeholder="Select Country"
            v-model="selectedCountry"
            @change="getTownsByCountry"
          >
            <el-option
              v-for="(country,index) in countries"
              class="select-default"
              :value="country"
              :label="index"
              :key="index"
            ></el-option>
          </el-select>
          <el-select
            size="mini"
            class="form-group border-input"
            placeholder="Select Location"
            v-model="selectedTown"
            @change="getVenuesByTown(selectedTown)"
          >
            <el-option
              v-for="(town,index) in towns[selectedCountry]"
              class="select-default"
              :value="town"
              :label="town"
              :key="index"
            ></el-option>
          </el-select>
     
          <el-button
            size="mini"
            @click="venues=[]"
            type="text"
            icon="el-icon-circle-close"
            circle
          >clear venues</el-button>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import json from "../../data/countries.json";
import { commonApi } from "../../api/common.js";
//import _ from "lodash";
import gql from "graphql-tag";
//import moment from "moment";

export default {
  name: "venue-filter",
  data() {
    return {
      countries: json,
      towns: 
        {
          EN: [],
          SS: [],
          WA: [],
          IE: [],
          ND: [],
          US: [],
          ES: []
        }
      ,
      venues: [],
      selectedTown:"Ashford",
      selectedCountry: "EN",
      total: 0
    };
  },
  methods: {

    getTownsByCountry(country) {
        this.$apollo
          .query({
            query: gql`
            {
              ClassRoomVenue(
                where: { country: {_eq: "${country}"} }
              ) {
                id
                town
              }
            }`,
            error(error) {
              this.error = JSON.stringify(error);
            }
          })
          .then(response => {
            for (let venue of response.data.ClassRoomVenue) {
                this.towns[country].push(venue.town);
            }
            this.towns[country] = this.towns[country].filter(function(item, i, ar){ return ar.indexOf(item) === i; }).sort();
            this.selectedTown = this.towns[country][0];
            this.getVenuesByTown(this.selectedTown);
            //this.towns[country] = this.towns[country].sort()
          });
    },

    getVenuesByTown(town) {
      this.$emit("loading", true);
      this.venues = [];
      if (town != 'All') {
        //if (this.towns[].length === 0) {
        this.$apollo
          .query({
            query: gql`
            {
              ClassRoomVenue(
                where: { town: {_eq: "${town}"},historic: {_eq: "0"} }
              ) {
                  id
                  phone
                  country
                  line1
                  line2
                  town
                  region
                  postcode
                  name
                  website
                  email
                  contactName
                  dateCreated
                  dateUpdated
                  mapGraphic
                  letterText
                  lat
                  long
                  historic
              }
            }`,
            error(error) {
              this.error = JSON.stringify(error);
            }
          })
          .then(response => {
            for (let venue of response.data.ClassRoomVenue) {
                this.venues.push(venue);
            }
            this.venues = this.venues.sort();
            this.$emit("loading", false);
            this.$emit("update:classVenues", this.venues);
          });
      }
    }
  },
 
  computed:{
    country:{ get(){return this.$store.getters.getQueries.country},set(value){ this.$store.commit('updatecountry', value)}},
    town:{get(){return this.$store.getters.getQueries.town},set(value){ this.$store.commit('updatetown', value)}},
  
  },

  async mounted(){
    //this.getVenuesByTown(this.selectedTown)
    this.getTownsByCountry("EN")
  }

};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/VenueFilter.vue